import filter from 'lodash/filter';
import isEmpty from 'lodash/isEmpty';

import { TInitialState } from '~/src/features/tariffBuilder/reducer';
import { EEntity } from '~/src/features/tariffBuilder/types/EEntity';

const isBaseTvSelected = (state: TInitialState) => {
    if (isEmpty(state[EEntity.tv])) {
        return false;
    }

    const baseTvGroup = filter(state[EEntity.tv], group => (group.alias === 'base'));
    return Object.values(baseTvGroup[0].items)[0].quantity > 0;
};

export default isBaseTvSelected;
